import { z } from 'zod/v3';

import { marketProductItemSchema } from './market-products';

/**
 * 카테고리별 top pv 상품 목록 (TopPvProductsResponseV3)
 */
export const topPvProductsSchema = z.object({
  /** 상품 목록 */
  products: z.array(marketProductItemSchema).optional(),
});
export type TopPvProducts = z.infer<typeof topPvProductsSchema>;

/**
 * top pv 카테고리 항목 (TopPvProductsCategoryDto)
 */
export const topPvCategorySchema = z.object({
  /** 카테고리 ID */
  categoryId: z.number(),
  /** 카테고리명 */
  categoryName: z.string(),
});
export type TopPvCategory = z.infer<typeof topPvCategorySchema>;

/**
 * top pv 카테고리 응답 (TopPvProductsCategoryResponseV2)
 */
export const topPvCategoriesSchema = z.object({
  /** 카테고리 목록 */
  data: z.array(topPvCategorySchema),
});
export type TopPvCategories = z.infer<typeof topPvCategoriesSchema>;
